import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class TagService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.tag.listUrl, ServiceConfig.tag.detailUrl);
  }
}



// WEBPACK FOOTER //
// ./src/services/tag.service.ts